import axios from "axios";
const { REACT_APP_ASSIST_API_URL, REACT_APP_ASSIST_API_TOKEN } = process.env;

const apiService = axios.create({
  baseURL: REACT_APP_ASSIST_API_URL,
  headers: {
    emquest_access_token: REACT_APP_ASSIST_API_TOKEN,
  },
});

const branchListApi = (brandId) => {
  return apiService.get(`/inf/stores?storeType=${brandId}`);
};
export default branchListApi;
